import moment from 'moment';

export const dateFormat = (date, format) => {
  const KoreanDate = new Date(date).setHours(new Date(date).getHours() - 9);
  return moment(KoreanDate).format(format);
};
